import CAAA1110ResponseModel from '@/api/data/CAA/CAAA1110/CAAA1110ResponseModel'
import CAAA1110RequestModel from '@/api/data/CAA/CAAA1110/CAAA1110RequestModel'
import RestService from '@/common/RestService'
import ApiUrlConstants from '@/common/ApiUrlConstants'

export default class CAAG1110Service {
  /**
   * CAAA1110 API処理呼出
   * @return caaa1110ResponseModel [ApiUrlConstants.CAAA1110]APIからのレスポンスデータ
   */
  public async callAPICAAA1110(id): Promise<CAAA1110ResponseModel> {
    const caaa1011RequestModel = new CAAA1110RequestModel()
    caaa1011RequestModel.id = id
    const caaa1110ResponseModel: CAAA1110ResponseModel = <
      CAAA1110ResponseModel
    > await RestService.post(ApiUrlConstants.CAAA1110, caaa1011RequestModel)
    return caaa1110ResponseModel
  }
}
